import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { api } from '../consts/url';
import { Observable } from 'rxjs';
import { UserModels, UserSettingsModels } from '@share-models';

type UserSettings = UserSettingsModels.UserSettingsDocument;

@Injectable()
export class UserSettingsService {
  constructor(private http: HttpClient) {}

  public create(data: UserSettings): Observable<UserSettings> {
    return this.http.post<UserSettings>(api.userSettings.crud, data);
  }

  public me(lang: string): Observable<UserSettings> {
    const url = lang
      ? `${api.userSettings.me}?lang=${lang}`
      : api.userSettings.me;
    return this.http.get<UserSettings>(url);
  }

  public update(data: UserSettings): Observable<UserSettings> {
    return this.http.put<UserSettings>(api.userSettings.crud, data);
  }

  public mutePushMobile(data: {
    confirmationCode: number;
    verificationId: string;
  }): Observable<UserModels.UserDocument> {
    return this.http.patch<UserModels.UserDocument>(
      api.userSettings.crud,
      data,
    );
  }

  public setLang(data: { lang: string }): Observable<unknown> {
    return this.http.put(api.userSettings.setLang, data);
  }

  public seTheme(theme: string): Observable<UserSettings> {
    return this.http.put<UserSettings>(api.userSettings.setTheme, { theme });
  }

  public setWeeklySubscription(
    subForWeekly: boolean,
  ): Observable<UserSettings> {
    return this.http.put<UserSettings>(api.userSettings.setWeeklySubscription, {
      subForWeekly,
    });
  }

  public setDontAskAgain(): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(api.users.g2DontAskAgain);
  }

  public setGlobalSearchSettings(
    globalSearchSettings: UserSettingsModels.GlobalSearchSettingsModel,
  ): Observable<UserSettings> {
    return this.http.put<UserSettings>(
      api.userSettings.setGlobalSearchSettings,
      { globalSearchSettings },
    );
  }
}
